import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'pagamento-file-reprovado-modal',
  templateUrl: './pagamento-file-reprovado-modal.component.html',
  styleUrls: ['./pagamento-file-reprovado-modal.component.scss']
})
export class PagamentoFileReprovadoModal implements OnInit {

  public detalhes = null; 
  public prefixo  = "web";

  constructor(
    public dialog: MatDialogRef<PagamentoFileReprovadoModal>,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private deviceService: DeviceDetectorService
  ){ 

    if(data.detalhes){
      this.detalhes = data.detalhes;
    }

  }  
  /**
   * 
   * Close
   * 
   */
  _close(){

    this.dialog.close();

  }
  /**
   * 
   * Open 
   * 
   */
  _open(){   

    window.open('https://'+this.prefixo+'.whatsapp.com/send?l=pt_pt&phone=555496745400', '_blank');

  } 
  /**
   * 
   * Inicializa as Funções
   * 
   * 
   */
  ngOnInit(){
    this.prefixo = this.deviceService.isDesktop() ? "web" : "api";
  }

}
